import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../app/hooks/useAuth'
import { UserRoleEnum } from '@/app/services/usersService/user'

interface RoleGuardProps {
  role?: UserRoleEnum
  /**
   * Libera a rota para o suporte independente do cargo dele na equipe.
   * O suporte não faz parte das equipes que atende, então o `role` dele é
   * calculado a partir dos times (USER/LEADER/...) e não alcança essas rotas.
   */
  allowSupport?: boolean
}

export function RoleGuard({ role, allowSupport }: RoleGuardProps) {
  const { user } = useAuth()

  enum roleGrade {
    SUPPORT,
    USER,
    LEADER,
    MANAGER,
    SUPERVISOR,
    ADMIN,
    SUPER_ADMIN,
  }

  if (!user?.role) return

  const isSupport = [UserRoleEnum.SUPPORT].includes(user.secondRole)

  if (allowSupport && isSupport) return <Outlet />

  if (role && roleGrade[role] > roleGrade[user.role])
    return <Navigate to={isSupport ? '/support' : '/transacoes'} replace />

  return <Outlet />
}
